module.exports = __webpack_public_path__ + "static/media/141-azerbaijan.df1ce840.svg";